

// Contact form success message - move focus 
window.addEventListener("load", function () {
  const successMsg = document.querySelector(".form-success");
  if (!successMsg) return;

  successMsg.setAttribute("role", "status");
  successMsg.setAttribute("tabindex", "-1");

  successMsg.scrollIntoView({ block: "start" });
  successMsg.focus({ preventScroll: true });
});

// Announcement Bar Slider
document.addEventListener("DOMContentLoaded", function () {

  // Announcement Bar Slider
  document
    .querySelectorAll(".announcement__bar-holder slider-component")
    .forEach(function (sliderEl) {

      let liveRegion = sliderEl.querySelector("[data-slide-status]");

      if (!liveRegion) {
        liveRegion = document.createElement("div");
        liveRegion.className = "visually-hidden";
        liveRegion.setAttribute("role", "status");
        liveRegion.setAttribute("aria-live", "polite");
        liveRegion.setAttribute("aria-atomic", "true");
        liveRegion.setAttribute("data-slide-status", "");

        sliderEl.appendChild(liveRegion);
      }

      function announceSlide() {
        const slides = sliderEl.querySelectorAll(".announcement__slide");
        const total = slides.length;

        if (total <= 1) return;

        const currentSlide = sliderEl.querySelector(
          ".announcement__slide.is-selected"
        );

        const index = currentSlide
          ? Array.from(slides).indexOf(currentSlide) + 1
          : 1;

        liveRegion.textContent = "Slide " + index + " of " + total;
      }

      function bindFlickitySelect() {
        if (sliderEl.flkty && !sliderEl.flkty._a11ySelectBound) {
          sliderEl.flkty.on("select", announceSlide);
          sliderEl.flkty._a11ySelectBound = true;

          announceSlide();
        }
      }

      sliderEl.addEventListener(
        "theme:slider:loaded",
        bindFlickitySelect
      );

      bindFlickitySelect();
    });


  // Cart Drawer - Close on Escape
  document.addEventListener("keydown", function (e) {

    if (e.key !== "Escape" && e.keyCode !== 27) return;

    const openDrawer = document.querySelector("cart-drawer.is-open");

    if (!openDrawer) return;

    const closeButton = openDrawer.querySelector(
      "[data-cart-drawer-close]"
    );

    if (closeButton) {
      closeButton.click();
    }
  });


  // Newsletter Form
  document
    .querySelectorAll("[data-newsletter-form]")
    .forEach(function (form) {

      const field = form.querySelector("[data-newsletter-field]");

      const errorBox = form.querySelector(
        ".newsletter__message--error"
      );

      if (!field || !errorBox) return;

      const errorId = errorBox.getAttribute("id");

      function messageFor() {
        const validity = field.validity;

        if (validity.valueMissing) {
          return "Please enter your email address to subscribe.";
        }

        if (validity.typeMismatch) {
          return "Please enter a valid email address, for example name@example.com.";
        }

        return (
          field.validationMessage ||
          "Please enter a valid email address."
        );
      }

      function showError() {
        errorBox.textContent = messageFor();

        form.classList.add("has-error");

        field.setAttribute("aria-invalid", "true");

        if (errorId) {
          field.setAttribute("aria-describedby", errorId);
        }

        errorBox.focus();
      }

      function clearError() {
        form.classList.remove("has-error");
        field.setAttribute("aria-invalid", "false");
      }

      form.addEventListener(
        "submit",
        function (e) {

          if (field.checkValidity()) {
            clearError();
            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();

          showError();
        },
        true
      );

      field.addEventListener("input", function () {

        if (field.validity.valid) {
          clearError();
        }

      });
    });


  // Login / Recover Password / Register / Contact Forms
  //
  // Validation errors are announced through ONE live region per form
  // (role="alert"), filled with all the messages at once:
  //   "Please fix the following errors: Email address is required. ..."
  // The per-field error boxes stay visible and linked to their field with
  // aria-describedby (read when the user reaches the field), but are no
  // longer live regions themselves - several alerts firing at once, plus a
  // focus move, made screen readers repeat or cut off the messages.
  document
    .querySelectorAll(
      "#Login form[novalidate], #Register form[novalidate], #contact-us-page[novalidate]"
    )
    .forEach(function (form) {

      const fields = form.querySelectorAll("[required]");
      const strings = (window.theme && window.theme.strings) || {};
      const intro = strings.formErrorsIntro || "Please fix the following errors:";

      // The live region must exist before text is put in it, so create it now.
      const announcer = document.createElement("div");
      announcer.className = "visually-hidden";
      announcer.setAttribute("role", "alert");
      announcer.setAttribute("aria-atomic", "true");
      announcer.setAttribute("data-form-error-announcer", "");
      form.insertBefore(announcer, form.firstChild);

      let announceTimer = null;

      function announce(messages) {
        // Clear first, then fill after a moment, so the same text is
        // announced again on a repeated submit.
        announcer.textContent = "";
        window.clearTimeout(announceTimer);

        if (!messages.length) return;

        // End each message with a full stop so screen readers pause between them.
        const sentences = messages.map(function (message) {
          return /[.!?]$/.test(message) ? message : message + ".";
        });

        announceTimer = window.setTimeout(function () {
          announcer.textContent = intro + " " + sentences.join(" ");
        }, 150);
      }

      function errorBoxFor(field) {
        const errorId = field.getAttribute("aria-describedby");
        return errorId ? document.getElementById(errorId) : null;
      }

      function messageFor(field) {
        const validity = field.validity;

        if (validity.valueMissing && field.dataset.errorValueMissing) {
          return field.dataset.errorValueMissing;
        }

        if (validity.typeMismatch && field.dataset.errorTypeMismatch) {
          return field.dataset.errorTypeMismatch;
        }

        return field.validationMessage;
      }

      function cleanText(el) {
        return el ? el.textContent.replace(/\s+/g, " ").trim() : "";
      }

      fields.forEach(function (field) {

        const errorBox = errorBoxFor(field);

        if (!errorBox) return;

        // The form's announcer does the announcing; see note above.
        errorBox.removeAttribute("role");

        field.addEventListener("invalid", function (e) {
          e.preventDefault();

          errorBox.textContent = messageFor(field);
          field.setAttribute("aria-invalid", "true");
        });

        ["input", "change"].forEach(function (eventName) {
          field.addEventListener(eventName, function () {

            if (field.validity.valid) {
              errorBox.textContent = "";
              field.removeAttribute("aria-invalid");
            }

          });
        });
      });

      // Listen on window in the capture phase so this runs BEFORE any other
      // submit listener. Shopify's hCaptcha script (spam protection on these
      // forms) also listens for submit and later submits the form itself,
      // even when we've called preventDefault() - that reloaded the page
      // before screen readers could announce the errors. Stopping the event
      // here means it never reaches hCaptcha while the form is invalid.
      // Valid forms are left alone, so hCaptcha still works normally.
      window.addEventListener("submit", function (e) {

        if (e.target !== form) return;

        // checkValidity() fires "invalid" on each bad field, which fills
        // the visible error boxes above.
        if (form.checkValidity()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const messages = Array.prototype.filter
          .call(fields, function (field) {
            return !field.validity.valid;
          })
          .map(function (field) {
            return cleanText(errorBoxFor(field)) || messageFor(field);
          })
          .filter(Boolean);

        announce(messages);
      }, true);

      // Login form: send it without reloading the page.
      //
      // Whether the email and password are right can only be checked by
      // Shopify, so the form has to be sent. Sent the normal way, the whole
      // page reloads and screen readers start again from the top of the new
      // page, so the error is missed. Instead the login form is sent in the
      // background. If Shopify answers with an error (e.g. "Incorrect email
      // or password."), the message is shown above the fields and announced
      // through the live region, and the page stays where it is. Any other
      // answer (logged in, captcha challenge, ...) is followed exactly like
      // a normal submit would.
      if (form.id === "customer_login" && window.fetch && window.DOMParser && window.URLSearchParams) {
        let sending = false;

        const announceText = function (text) {
          announcer.textContent = "";
          window.clearTimeout(announceTimer);
          announceTimer = window.setTimeout(function () {
            announcer.textContent = text;
          }, 150);
        };

        const showLoginError = function (text) {
          let box = form.querySelector("[data-form-general-error]");

          if (!box) {
            box = document.createElement("div");
            box.id = "customer_login-error";
            box.setAttribute("data-form-general-error", "");
            box.setAttribute("tabindex", "-1");
            form.insertBefore(box, announcer.nextSibling);
          }

          // The announcer does the announcing, so this box is not a live
          // region itself (otherwise the message would be read twice).
          box.removeAttribute("role");
          box.removeAttribute("autofocus");

          const wrapper = document.createElement("div");
          const list = document.createElement("ul");
          const item = document.createElement("li");
          wrapper.className = "errors";
          item.textContent = text;
          list.appendChild(item);
          wrapper.appendChild(list);
          box.textContent = "";
          box.appendChild(wrapper);

          return box;
        };

        const resetCaptcha = function () {
          // A captcha token only works once; get a fresh one for the next try.
          try {
            const frame = form.querySelector("iframe[data-hcaptcha-widget-id]");
            if (window.hcaptcha && frame) {
              window.hcaptcha.reset(frame.getAttribute("data-hcaptcha-widget-id"));
            }
          } catch (error) {}
        };

        const submitNormally = function () {
          HTMLFormElement.prototype.submit.call(form);
        };

        const sendLogin = function () {
          if (sending) return;
          sending = true;

          let body;
          try {
            body = new URLSearchParams(new FormData(form));
          } catch (error) {
            submitNormally();
            return;
          }

          window
            .fetch(form.action, { method: "POST", body: body, credentials: "same-origin" })
            .then(function (response) {
              const target = response.url || form.action;

              // Logged in, captcha challenge, etc.: go where Shopify sent us.
              if (new URL(target, window.location.href).pathname.indexOf("/account/login") !== 0) {
                window.location.assign(target);
                return;
              }

              return response.text().then(function (html) {
                const page = new DOMParser().parseFromString(html, "text/html");
                const sentForm = page.getElementById("customer_login");
                const messages = sentForm
                  ? Array.prototype.map
                      .call(sentForm.querySelectorAll("[data-form-general-error], .form-field__error"), cleanText)
                      .filter(Boolean)
                  : [];

                if (!messages.length) {
                  window.location.assign(target);
                  return;
                }

                sending = false;
                resetCaptcha();

                const password = form.querySelector('input[type="password"]');
                if (password) password.value = "";

                const box = showLoginError(messages.join(" "));
                announceText(messages.join(" "));

                // Focus normally stays on the Sign In button. Only if it got
                // lost (e.g. after a captcha pop-up) put it on the message, so
                // keyboard users are not sent back to the top of the page.
                const current = document.activeElement;
                if (!current || current === document.body) box.focus();
              });
            })
            .catch(function () {
              // Network problem etc.: fall back to a normal submit.
              submitNormally();
            });
        };

        // Shopify's captcha script, once it loads, takes over form.submit()
        // and later calls the submit function it found there, after adding a
        // captcha token. Leave ours there for it to find, so that call sends
        // the form in the background instead of reloading the page.
        if (!form.hasAttribute("data-hcaptcha-bound")) {
          try {
            form.submit = sendLogin;
          } catch (error) {}
        }

        // No captcha on the form: send it in the background ourselves. This
        // runs after the validation listener above, so only valid forms get
        // here.
        window.addEventListener("submit", function (e) {
          if (e.target !== form || e.defaultPrevented || form.hasAttribute("data-hcaptcha-bound")) return;

          e.preventDefault();
          e.stopImmediatePropagation();
          sendLogin();
        }, true);
      }

      // Errors from the server (the page reloaded after a submit, e.g. "Incorrect
      // email or password."). Text that is already on the page at load is not
      // reliably announced by live regions, especially while the page itself is
      // being read out - so move focus to the message, which screen readers
      // always read. (The template also autofocuses it; this is a backup in
      // case something else took focus during page load.)
      const generalError = form.querySelector("[data-form-general-error]");

      if (generalError && cleanText(generalError)) {
        const focusGeneralError = function () {
          // Only for the form that is actually shown (login vs. recover).
          const current = document.activeElement;
          if (form.offsetParent === null || (current && current !== document.body && current !== generalError)) return;

          // If autofocus already put focus here, that happened while the page
          // was still loading, which screen readers often don't report (they
          // start reading from the top instead). Take it off and put it back
          // a moment later, so they get a real focus change now.
          if (current === generalError) {
            generalError.blur();
            window.setTimeout(focusGeneralError, 100);
            return;
          }

          if (!generalError.hasAttribute("tabindex")) {
            generalError.setAttribute("tabindex", "-1");
          }

          generalError.focus();
        };

        if (document.readyState === "complete") {
          window.setTimeout(focusGeneralError, 300);
        } else {
          window.addEventListener("load", function () {
            window.setTimeout(focusGeneralError, 300);
          });
        }
      } else {
        // Field errors from the server: announce them through the live region.
        const serverMessages = Array.prototype.map
          .call(form.querySelectorAll(".form-field__error"), cleanText)
          .filter(Boolean);

        if (serverMessages.length) {
          window.setTimeout(function () {
            if (form.offsetParent !== null) announce(serverMessages);
          }, 500);
        }
      }
    });


  document.querySelectorAll('.accordion__content a[target="_blank"]').forEach(function (link) {
    link.removeAttribute('target');
  });


  // Search results - announce the result count once the results page has
  // loaded. Search is a real full-page submission (not AJAX), so there's no
  // reliable moment to announce a "loading" state mid-navigation - the old
  // page's DOM is gone before anything could be spoken. What we can do
  // reliably is make sure screen reader users learn the outcome the moment
  // the new page lands, instead of the browser silently dropping focus at
  // the top of the page with no indication anything changed.
  (function () {
    const resultsStatus = document.querySelector("[data-results-count]");

    if (!resultsStatus) return;

    resultsStatus.setAttribute("role", "status");
    resultsStatus.setAttribute("aria-live", "polite");
    resultsStatus.setAttribute("tabindex", "-1");
    resultsStatus.focus({ preventScroll: true });
  })();


  // Cart - Remove link has role="button", so Space must activate it like a
  // real button (by default Space on a link just scrolls the page).
  document.addEventListener("keydown", function (e) {
    if (e.key !== " " && e.key !== "Spacebar") return;

    const removeControl = e.target.closest("[data-item-remove]");

    if (!removeControl) return;

    e.preventDefault();
    removeControl.click();
  });


  // Cart - announce when a product is removed

  (function () {
    let liveRegion = document.querySelector("[data-cart-remove-announcer]");

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("role", "status");
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");
      liveRegion.setAttribute("tabindex", "-1");
      liveRegion.setAttribute("data-cart-remove-announcer", "");
      document.body.appendChild(liveRegion);
    }

    document.addEventListener("click", function (e) {
      const removeControl = e.target.closest("[data-item-remove]");

      if (!removeControl) return;

      const item = removeControl.closest("[data-item]");
      const productTitleEl = item && item.querySelector(".cart__item__title");
      const itemTitle = productTitleEl
        ? productTitleEl.textContent.trim()
        : item && item.getAttribute("data-item-title");

      if (!itemTitle) return;

      const strings = (window.theme && window.theme.strings) || {};
      const template = strings.productRemoved || "{title} has been removed from cart";
      const message = template.replace("{title}", itemTitle);

      const announce = function () {
        // Wait past the theme's own 100ms delayed focus move so we go last.
        window.setTimeout(function () {
          const returnFocusTo = document.activeElement;

          liveRegion.textContent = message;
          liveRegion.focus({ preventScroll: true });

          window.setTimeout(function () {
            if (
              returnFocusTo &&
              returnFocusTo !== document.body &&
              document.contains(returnFocusTo) &&
              typeof returnFocusTo.focus === "function" &&
              returnFocusTo.offsetParent !== null
            ) {
              // Only steal focus back if that element is still visible (e.g.
              // the drawer is still open). If the user has since closed the
              // drawer, the app has already returned focus somewhere
              // sensible (like the cart toggle button) - don't fight that.
              returnFocusTo.focus({ preventScroll: true });
            }

            liveRegion.textContent = "";
          }, 4000);
        }, 300);
      };

      document.addEventListener("theme:cart:change", announce, { once: true });

      // Fallback in case the cart update fails to fire the event above.
      window.setTimeout(function () {
        document.removeEventListener("theme:cart:change", announce);
        if (!liveRegion.textContent) announce();
      }, 2000);
    });
  })();


  // Cart - after "Add to cart", read "<product> added to cart. Cart drawer
  // opened." exactly once.
  // The theme fires "theme:product:added", opens the drawer, then calls
  // theme.a11y.trapFocus() to focus the close button. While an "added" message
  // is waiting we instead:
  //   1. make the message the dialog's name (aria-labelledby -> hidden span),
  //   2. focus the dialog itself.
  // The screen reader then says "<message>, dialog" once. Focusing a separate
  // message element made screen readers read the message AND the dialog.
  // When focus moves on, the dialog's name goes back to "Cart".

  (function () {
    let lastAddedTitle = "";
    let drawerOpenAtClick = false;
    let pendingMessage = false;

    const getDialog = function (root) {
      return root && root.querySelector ? root.querySelector("[data-cart-drawer-inner]") : null;
    };

    // Name the dialog with the message and set up clean-up for when focus
    // leaves the dialog element.
    const prepareDialog = function (drawer, dialog, message) {
      const originalLabel = dialog.getAttribute("aria-labelledby");
      const hadTabindex = dialog.hasAttribute("tabindex");

      dialog.setAttribute("aria-labelledby", message.id);

      // Shift+Tab from the dialog itself: go to the drawer's last control
      // instead of leaving the drawer. (Tab goes on to the close button.)
      const onKeydown = function (e) {
        if (e.target !== dialog || e.key !== "Tab" || !e.shiftKey) return;

        const helper = window.theme && window.theme.a11y;
        const items = helper && helper.focusable ? helper.focusable(drawer) : [];
        const last = items.filter(function (item) {
          return item !== dialog;
        }).pop();

        if (last) {
          e.preventDefault();
          last.focus();
        }
      };

      dialog.addEventListener("keydown", onKeydown);

      dialog.addEventListener(
        "blur",
        function () {
          dialog.removeEventListener("keydown", onKeydown);

          if (originalLabel) {
            dialog.setAttribute("aria-labelledby", originalLabel);
          } else {
            dialog.removeAttribute("aria-labelledby");
          }

          message.textContent = "";

          // Run after the theme's own blur handler (it puts tabindex back),
          // so the dialog doesn't become a stop in the focus trap later.
          window.setTimeout(function () {
            if (!hadTabindex) dialog.removeAttribute("tabindex");
          }, 0);
        },
        { once: true }
      );
    };

    // Wrap the theme's focus helper (theme.js loads deferred, so do it lazily).
    const patchTrapFocus = function () {
      const helper = window.theme && window.theme.a11y;

      if (!helper || helper.cartMessagePatched || typeof helper.trapFocus !== "function") return;

      const originalTrapFocus = helper.trapFocus;

      helper.trapFocus = function (container, options) {
        const message =
          pendingMessage && container && container.querySelector
            ? container.querySelector("[data-cart-added-announcer]")
            : null;
        const dialog = message ? getDialog(container) : null;

        if (message && dialog && message.textContent) {
          pendingMessage = false;
          prepareDialog(container, dialog, message);
          options = Object.assign({}, options, { elementToFocus: dialog });
        }

        return originalTrapFocus.call(this, container, options);
      };

      helper.cartMessagePatched = true;
    };

    patchTrapFocus();

    // Remember which product the shopper tried to add, and whether the drawer
    // was already open (the theme opens it before "theme:product:added").
    document.addEventListener(
      "click",
      function (e) {
        const addButton = e.target.closest('[name="add"], [data-add-to-cart], [data-add-to-cart-bar]');

        if (!addButton) return;

        let scope = addButton.parentElement;
        let titleEl = null;

        while (scope && scope !== document.body && !titleEl) {
          titleEl = scope.querySelector(
            ".product__title, .product-item__title, .cart-bar__product__title, [data-product-title]"
          );
          scope = scope.parentElement;
        }

        lastAddedTitle = titleEl ? titleEl.textContent.trim() : "";

        const drawerEl = document.querySelector("cart-drawer");
        drawerOpenAtClick = !!(drawerEl && drawerEl.classList.contains("is-open"));
      },
      true
    );

    document.addEventListener("theme:product:added", function () {
      const message = document.querySelector("[data-cart-added-announcer]");
      const drawer = document.querySelector("cart-drawer");
      const dialog = getDialog(drawer);

      if (!message || !drawer || !dialog) return;

      // If the drawer was already open, only say "added to cart".
      const wasOpen = drawerOpenAtClick;
      drawerOpenAtClick = false;

      const strings = (window.theme && window.theme.strings) || {};
      const addedText = (strings.productAddedToCart || "{title} added to cart.")
        .replace("{title}", lastAddedTitle || "Item");
      const openedText = strings.cartDrawerOpened || "Cart drawer opened.";

      lastAddedTitle = "";
      message.textContent = wasOpen ? addedText : addedText + " " + openedText;

      patchTrapFocus();
      pendingMessage = true;

      // If the theme doesn't move focus (e.g. the drawer was already open),
      // do the same thing ourselves.
      window.setTimeout(function () {
        if (!pendingMessage) return;
        pendingMessage = false;

        if (drawer.classList.contains("is-open") && message.textContent) {
          prepareDialog(drawer, dialog, message);
          dialog.setAttribute("tabindex", "-1");
          dialog.focus({ preventScroll: true });
        } else {
          message.textContent = "";
        }
      }, 3000);
    });
  })();


  // Grid slider announce the slide
  // that Next/Previous just scrolled into view. The slider itself only

  document.querySelectorAll("grid-slider").forEach(function (gridSlider) {
    const slider = gridSlider.querySelector("[data-grid-slider]");

    if (!slider) return;

    let liveRegion = gridSlider.querySelector("[data-grid-slider-status]");

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("role", "status");
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");
      liveRegion.setAttribute("data-grid-slider-status", "");
      gridSlider.appendChild(liveRegion);
    }

    function labelFor(slide) {
      const caption = slide.querySelector(".collection-item__info");

      if (caption && caption.textContent.trim()) {
        return caption.textContent.trim();
      }

      const image = slide.querySelector("img[alt]");

      if (image && image.alt.trim()) {
        return image.alt.trim();
      }

      const slides = Array.prototype.slice.call(slider.querySelectorAll("[data-grid-item]"));

      return "Slide " + (slides.indexOf(slide) + 1) + " of " + slides.length;
    }

    function afterScrollSettled(callback) {
      if ("onscrollend" in window) {
        slider.addEventListener(
          "scrollend",
          function () {
            callback();
          },
          { once: true }
        );
      } else {
        window.setTimeout(callback, 500);
      }
    }

    gridSlider.addEventListener("click", function (e) {
      const button = e.target.closest("[data-button-arrow]");

      if (!button) return;

      const firstVisible = slider.querySelector("[data-grid-item].is-visible");

      if (!firstVisible) return;

      let targetSlide = null;

      if (button.hasAttribute("data-button-prev")) {
        targetSlide = firstVisible.previousElementSibling;
      }

      if (button.hasAttribute("data-button-next")) {
        targetSlide = firstVisible.nextElementSibling;
      }

      if (!targetSlide) return;

      afterScrollSettled(function () {
        liveRegion.textContent = "";
        window.requestAnimationFrame(function () {
          liveRegion.textContent = labelFor(targetSlide);
        });
      });
    });
  });


  // Product image gallery - announce the newly displayed image when
  // Previous/Next (or a variant swatch, swipe, or arrow keys) changes the
  // active slide. 
  document.querySelectorAll("product-images").forEach(function (productImages) {
    const mediaList = productImages.querySelector("[data-product-media-list]");

    if (!mediaList) return;

    let liveRegion = productImages.querySelector("[data-media-status]");

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.className = "visually-hidden";
      liveRegion.setAttribute("role", "status");
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");
      liveRegion.setAttribute("data-media-status", "");
      productImages.appendChild(liveRegion);
    }

    function announceActiveMedia() {
      const items = mediaList.querySelectorAll("[data-image-id]");
      const active = mediaList.querySelector("[data-image-id].media--active");

      console.log("[a11y-debug] announceActiveMedia fired", { itemsLength: items.length, activeId: active && active.getAttribute("data-image-id"), liveRegionConnected: liveRegion.isConnected });

      if (!active) return;

      const index = Array.prototype.indexOf.call(items, active) + 1;
      const total = items.length;
      const image = active.querySelector("img[alt]");
      const altText = image && image.alt.trim();

      const position = "image " + index + " of " + total;
      const message = altText ? altText + ", " + position : "Product " + position;

      liveRegion.textContent = "";
      window.requestAnimationFrame(function () {
        liveRegion.textContent = message;
      });
    }

    productImages.addEventListener("theme:media:select", announceActiveMedia);
  });

});

// Fixes that adjust attributes set by accessibilty.js. accessibilty.js runs its jQuery ready
// handlers (and a MutationObserver that re-applies target="_blank") after DOMContentLoaded,
// so these run on window load and again after later DOM changes.
(function () {
  // 1. CCPA opt-out link: same tab, label describes the destination
  function fixCcpaLink() {
    document.querySelectorAll('a[href*="/pages/ccpa-opt-out"]').forEach(function (link) {
      link.removeAttribute("target");
      link.removeAttribute("rel");
      link.setAttribute("aria-label", link.textContent.trim() + " click ccpa-opt-out page");
    });
  }

  // 2. Rewards "JOIN NOW" hero button: label with the destination instead of the heading
  function fixJoinNowButton() {
    document.querySelectorAll('.hero__button a[href*="/pages/rewards-landing"]').forEach(function (btn) {
      var text = btn.textContent.trim();
      if (text.toUpperCase() === "JOIN NOW") {
        btn.setAttribute("aria-label", text + ": rewards-landing");
      }
    });
  }

  // 3. Scrollable table wrappers must be reachable with the keyboard.
  // tabindex="0" is added only while the wrapper actually overflows. No visual change.
  function fixScrollableTables() {
    document.querySelectorAll(".rte__table-wrapper").forEach(function (wrapper) {
      var isScrollable =
        wrapper.scrollWidth > wrapper.clientWidth ||
        wrapper.scrollHeight > wrapper.clientHeight;

      if (isScrollable) {
        wrapper.setAttribute("tabindex", "0");
      } else if (wrapper.getAttribute("tabindex") === "0") {
        wrapper.removeAttribute("tabindex");
      }
    });
  }

  // 4. Policy pages: bold lead-in lines act as section headings but have no heading markup.
  // Shapes found in the policy content:
  //   <p><strong>Title</strong><br>text...</p>      (refund policy)
  //   <p><strong>SECTION 1 - TITLE</strong></p>     (terms of service)
  //   <strong>OVERVIEW</strong> <br>                (terms of service, directly inside .rte)
  // Each one becomes a real <h2> that keeps the exact look of the original <strong>
  // (computed styles are copied inline and it stays inline so the layout is unchanged).
  function fixPolicyHeadings() {
    var props = [
      "fontFamily", "fontSize", "fontWeight", "fontStyle", "lineHeight", "letterSpacing",
      "textTransform", "textDecoration", "textAlign", "color"
    ];

    function isBlank(node) {
      return node.nodeType === 3 && !node.textContent.trim();
    }
    function prevContent(node) {
      var n = node.previousSibling;
      while (n && isBlank(n)) n = n.previousSibling;
      return n;
    }
    function nextContent(node) {
      var n = node.nextSibling;
      while (n && isBlank(n)) n = n.nextSibling;
      return n;
    }
    function isBr(node) {
      return !!node && node.nodeType === 1 && node.tagName === "BR";
    }

    document.querySelectorAll(".shopify-policy__body .rte strong, .shopify-policy__body .rte b").forEach(function (strong) {
      var parent = strong.parentElement;
      var text = strong.textContent.trim();
      if (!parent || !text || text.length > 150) return;

      var next = nextContent(strong);

      if (parent.tagName === "P") {
        // must be the first content of the paragraph, then either a <br> or nothing else
        if (prevContent(strong)) return;
        if (next && !isBr(next)) return;
      } else if (parent.classList.contains("rte")) {
        // loose <strong> directly inside .rte, followed by <br>
        if (!isBr(next)) return;
      } else {
        return;
      }

      var computed = window.getComputedStyle(strong);
      var h2 = document.createElement("h2");
      props.forEach(function (prop) {
        h2.style[prop] = computed[prop];
      });
      h2.style.display = "inline";
      h2.style.margin = "0";
      h2.style.padding = "0";

      while (strong.firstChild) h2.appendChild(strong.firstChild);
      parent.replaceChild(h2, strong);
    });
  }

  function applyFixes() {
    fixCcpaLink();
    fixJoinNowButton();
    fixScrollableTables();
    fixPolicyHeadings();
  }

  var timer;
  function scheduleFixes() {
    clearTimeout(timer);
    timer = setTimeout(applyFixes, 150);
  }

  window.addEventListener("load", function () {
    applyFixes();

    // Wrappers are created by theme.js; content can also be added later (theme editor, dynamic content)
    if ("MutationObserver" in window) {
      new MutationObserver(scheduleFixes).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
    window.addEventListener("resize", scheduleFixes);
  });
})();
